export default "__VITE_ASSET__BElkVS02__"